import './style.scss';
import Offcanvas from 'react-bootstrap/Offcanvas';

import { Header } from './header';
import { Tabs } from './tabs';

type EssentialSidePanelProps = {
  isSidePanelOpened: boolean;
  toggleSidePanel: () => void;
};

export function EssentialSidePanel({ isSidePanelOpened, toggleSidePanel }: EssentialSidePanelProps) {
  return (
    <Offcanvas
      role="complementary"
      className="border-end border-opacity-70 shadow-none essential-side-panel"
      show={isSidePanelOpened}
      aria-hidden={!isSidePanelOpened}
      aria-label="Tabs side panel"
      onHide={toggleSidePanel}
      backdrop={false}
      scroll={false}
      enforceFocus={false}
    >
      <Header toggleSidePanel={toggleSidePanel} />
      <Offcanvas.Body className="ps-2 pe-1 overflow-auto scrollbar-sm">
        <Tabs />
      </Offcanvas.Body>
    </Offcanvas>
  );
}
